import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("brand/index"),
  
  store: (userData) => clientAuth.post('brand/store', { json: userData }),
  

  show:(id)=>clientAuth.get('brand/show/'+id),

  update:(id,userData)=>clientAuth.post('brand/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`brand/destroy/${id}`),
};